import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { toast } from 'react-hot-toast';
import './AddEditCertificateModal.css';
import edit_lot_base_image from '../../../src/assets/images/edit_lot_base_image.png';
import edit_lot from '../../../src/assets/images/edit_lot.png';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Autocomplete, Grid, useMediaQuery, Checkbox, FormControlLabel, FormControl, Select, MenuItem, InputLabel, FormHelperText } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateShipmentProductLotQty, addShipmentProductLots, fetchStockById } from '../../redux/shipmentSlice'
import { Formik } from 'formik';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { createMyProfileCertificate, fetchCertificateIssuingBody, fetchCertificateList, fetchMyProfileCertificateDetails, fetchMyProfileData, updateMyProfileCertificate } from '../../redux/myProfileSlice';
import dayjs from 'dayjs';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(2),
  },
  '& .MuiPaper-root': {
    borderRadius: theme.spacing(2), // To adjust the modal borderRadius
  },
}));

const AddEditCertificateModalComponent = ({ isOpen, onClose, actionType, isEditCertificate, updateActionType }) => {
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();
  // console.log("stock",stock)
  // console.log("shipmentProductId",shipmentProductId);
  const userDetails = useSelector(state => state.auth.userDetails) || {}
  const [consumeProductQty, setConsumeProductQty] = useState('');
  const [errors, setErrors] = useState('');
  // const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.mp4)$/i;
  const [bannerImagePath, setBannerImagePath] = useState()
  const [fileUrl, setFileUrl] = useState("")
  const imageUrl = 'http://localhost:3200/' + bannerImagePath // TODO TEMPORARY IMAGE UPLOAD 
  const [buttonDisabled, setButtonDisabled] = useState(true)
  const [imageLoading, setImageLoading] = useState(true)
  const [imageError, setImageError] = useState("")
  const { addCertificateList, loading, addCertificateIssuingList } = useSelector((state) => state.myProfile);
  // const addCertificateIssuingList = useSelector((state) => state.myProfile.addCertificateIssuingList);
  const [dateOfIssue, setDateOfIssue] = useState(null);
  const [dateOfExpiry, setDateofExpiry] = useState(null);
  const [isExport, setIsExport] = useState(false);
  console.log(isEditCertificate, 'isEditCErtificate in modal is ')

  const handleTextChange = (event) => {
    const { value } = event.target;
    const enteredQty = parseInt(value);
    const maxQty = stock?.productQty || 0;
    if (!value.trim()) {
      setErrors('Quantity is required');
    } else if (enteredQty < 1 || enteredQty > maxQty) {
      setErrors(`Invalid Quantity`);
    } else {
      setErrors('');
      setConsumeProductQty(enteredQty);
    }
  };

  const defaultValues = {
    // certificateName: isEditCertificate.certificateName || '',
    certificateId: '',
    // certificateIssuingBodyName: isEditCertificate.certificateIssuingBodyName || '',
    certificateIssuingBodyId: 0,
    credentialsId:  '',
    credentialsUrl: '',
    dateOfIssue: '',
    dateOfExpiry:  '',
    certificateDoesNotExpireYn: false ,
    certificateListId: '',
    otherCertName: ''
}

const editMyProfileValue = actionType === 'edit' ? {
  certificateId: isEditCertificate.certificateId || '',
  // certificateIssuingBodyName: isEditCertificate.certificateIssuingBodyName || '',
  certificateIssuingBodyId: isEditCertificate.certificateIssuingBodyId || 0,
  credentialsId: isEditCertificate.credentialsId || '',
  credentialsUrl: isEditCertificate.credentialsUrl || '',
  dateOfIssue: isEditCertificate.dateOfIssue ? dayjs(isEditCertificate.dateOfIssue) : dayjs(),
  dateOfExpiry: isEditCertificate.dateOfExpiry ? dayjs(isEditCertificate.dateOfExpiry) : dayjs(),
  certificateDoesNotExpireYn: isEditCertificate.certificateDoesNotExpireYn == 0 ? false : true ,
  certificateListId: isEditCertificate.certificateListId || '',
  otherCertName: isEditCertificate.otherCertName || ''
} : defaultValues;

  useEffect(() => {
    dispatch(fetchCertificateList())
    dispatch(fetchCertificateIssuingBody())
  }, [dispatch]);

  const handleClose = () => {
    // setOpen(false);
    onClose(false);
    const companyId = userDetails.company?.companyKeyId;
    const url = `/companies/${companyId}`;

    const certificateUrl = `/companies/${companyId}`
    if (companyId) {
      dispatch(fetchMyProfileData(url)).then(() => {
      });

    }
    const queryParams = { type: "certificates", pageNumber: 1, pageSize: 12 }

    dispatch(fetchMyProfileCertificateDetails({ companyId, queryParams }))

  };

  const handleSubmit = (formattedValues) => {
    console.log("handleEditCertificateChange", formattedValues);
    // const [certificateIssuingBodyName, ...sendParams] = formattedValues;
    dispatch(createMyProfileCertificate({ createMyProfileCertificate: formattedValues }))
      .then((response) => {
        if(response.payload.data===true){
        toast.success(response.payload.msg);
        handleClose();
        }
        else{
          toast.error(response.payload.msg);
        }
      })
      .catch((error) => {
        console.error("Fetching user details error:", error);
      });
      handleClose()
  };

  const handleClickOpen = () => {
    // setOpen(true);
  };
 

  const handleImageChange = (e) => {
    // if (e.target.files[0]) {
    //     setFileUrl(URL.createObjectURL(e.target.files[0]));
    //     setFile(e.target.files[0])
    // }
    // setButtonDisabled(false)
  }

  const handleImageUpload = async (event) => {
    // event.preventDefault()
    // setImageLoading(true)
    // const formData = new FormData()
    // formData.append("image", file)
    // try {
    //     const result = await uploadBanner(formData)
    //     setBannerImagePath(result.data.filePath)
    //     setError(false)
    //     setImageError("")
    //     setErrorMessage("")
    // }
    // catch (err) {
    //     setError(true)
    //     setErrorMessage(err.response.data.msg)
    // }
    // setImageLoading(false)
  }
 
  const handleFromDateChange = (date) => {
    setDateOfIssue(date);
  };

  const handleToDateChange = (date) => {
    setDateofExpiry(date);
  };

  const handleEditCertificateChange = (formattedValues) => {
    console.log("handleEditCertificateChange", formattedValues);
    dispatch(updateMyProfileCertificate({ editedMyProfileCertificateData: formattedValues }))
      .then((response) => {
        const companyDetails = response.payload
        console.log('For toast message', response)
        toast.success(response.payload.msg);
        if (companyDetails.data === true) {
          console.log('Inside condition for close')
          // actionType('add')
          updateActionType('add')
            // navigate(-1);
            handleClose()
        }
      })
      .catch((error) => {
        console.error("Fetching user details error:", error);
      });
  };
  console.log('Dropdown values', isEditCertificate, actionType)
  const { ...rest } = location.state?.isEditCertificate || {};
  // console.log('In add edit certificte modal, rest is ', rest, isEditCertificate)
  console.log('certificate Checkbox is ', isEditCertificate.certificateDoesNotExpireYn, actionType)
  return (
    <React.Fragment >
      <BootstrapDialog
        // fullScreen={fullScreen}
        fullWidth={false}
        maxWidth='lg'
        scroll='body'
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
      // className='editLotshipmentDeclineModalBody'
      >
        <DialogTitle sx={{ m: 0, height: "0px" }} id="customized-dialog-title" fullWidth>
          {/* Modal title */}
          <div className='AddEditCertificateModalImagediv'>
            <img
              className='firstModalImage'
              src={edit_lot_base_image}
            />
            <img
              className='secondModalImage'
              src={edit_lot}
            />
            <h4 className='headingForAddEditCertificateModal'> Add Certificate </h4>
          </div>
        </DialogTitle>
        <IconButton

          // disabled
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
            backgroundColor: "white",
            height: "7%",
            width: "6%",
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers sx={{ top: 20, marginTop: 17 }}>
          <Formik
            initialValues={editMyProfileValue}
            // initialValues={{
            //   // certificateName: isEditCertificate.certificateName || '',
            //   certificateId: isEditCertificate.certificateId || '',
            //   // certificateIssuingBodyName: isEditCertificate.certificateIssuingBodyName || '',
            //   certificateIssuingBodyId: isEditCertificate.certificateIssuingBodyId || 0,
            //   credentialsId: isEditCertificate.credentialsId || '',
            //   credentialsUrl: isEditCertificate.credentialsUrl || '',
            //   dateOfIssue: isEditCertificate.dateOfIssue ? dayjs(isEditCertificate.dateOfIssue) : dayjs(),
            //   dateOfExpiry: isEditCertificate.dateOfExpiry ? dayjs(isEditCertificate.dateOfExpiry) : dayjs(),
            //   certificateDoesNotExpireYn: isEditCertificate.certificateDoesNotExpireYn == 0 ? false : true ,
            //   certificateListId: isEditCertificate.certificateListId || '',
            //   otherCertName: isEditCertificate.otherCertName || ''
            // }}

            enableReinitialize={true}
            // validationSchema={productSchema}
            onSubmit={(values, { setSubmitting }) => {
              const formattedValues = {
                certificateId: fetchMyProfileCertificateDetails.certificateId,
                ...values,
                certificateDoesNotExpireYn: (values.certificateDoesNotExpireYn == true) ? "1" : "0" 
              };
              if (actionType === "edit") {
                handleEditCertificateChange({ ...formattedValues });

              }
              else {
                handleSubmit({ ...formattedValues })
              }
              onSubmit(formattedValues);
              setSubmitting(false);
            }}
          >
            {/* {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => ( */}
            {formikProps => {
                    const {
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        setFieldValue,
                    } = formikProps;

                    const handleExportChange = (event) => {
                      // setIsExport(event.target.checked);
                      setFieldValue("certificateDoesNotExpireYn", event.target.checked);
                      console.log('Checked is -- ', event)
                    };

                    return(
              <form onSubmit={handleSubmit}>

                {/* <Box sx={{ display: 'flex', gap: 2 }}> */}
                <div className="row">
                  <h4 className="mb-3">Certificate Issuing Details</h4>
                  <div className="col-md-4 cs-form mb-2">

                    <FormControl className='md-input'
                    >
                      <InputLabel id="certificate-name">Certificate Name*</InputLabel>
                      <Select
                        labelId="certificate-name"
                        name="certificateListId"
                        value={values.certificateListId}
                        label={'Certificate Name'}
                        // onChange={handleChange}
                        onChange={(event) => {
                          const selectedCertId = event.target.value;
                          console.log('--------------------------> selectedcertid', selectedCertId)
                          const selectedName = addCertificateList.find(option => option.certificateListId === selectedCertId)?.certificateName || '';

                          handleChange({ target: { name: 'certificateListId', value: selectedCertId } });
                          // handleChange({ target: { name: 'certificateIssuingBodyName', value: selectedName } });
                        }}
                        error={touched.certificateName && Boolean(errors.certificateName)}
                      >
                        {!loading ? (addCertificateList.map((option) => (
                          <MenuItem key={option.certificateId} value={option.certificateId}>
                            {option.certificateName}
                          </MenuItem>
                        )
                        )) : null}
                      </Select>
                      <FormHelperText>{touched.certificateName && errors.certificateName}</FormHelperText>
                    </FormControl>
                  </div>
                  <div className="col-md-4 cs-form mb-2">

                    <FormControl className='md-input'
                    >
                      <InputLabel id="unit-label">Certificate Issuing Body*</InputLabel>
                      <Select
                        labelId="unit-label"
                        name="certificateIssuingBodyId"
                        value={values.certificateIssuingBodyId}
                        label={'Certificate Name'}
                        // onChange={handleChange()}
                        onChange={(event) => {
                          const selectedId = event.target.value;
                          const selectedName = addCertificateIssuingList.find(option => option.certificateIssuingBodyId === selectedId)?.certificateIssuingBodyName || '';

                          handleChange({ target: { name: 'certificateIssuingBodyId', value: selectedId } });
                          // handleChange({ target: { name: 'certificateIssuingBodyName', value: selectedName } });
                        }}
                        error={touched.certificateIssuingBodyName && Boolean(errors.certificateIssuingBodyName)}
                      >
                        {!loading ? (addCertificateIssuingList.map((option) => (
                          <MenuItem key={option.certificateIssuingBodyId} value={option.certificateIssuingBodyId}>
                            {option.certificateIssuingBodyName}
                          </MenuItem>
                        )
                        )) : null}
                      </Select>
                      <FormHelperText>{touched.productUom && errors.productUom}</FormHelperText>
                    </FormControl>
                  </div>

                </div>
                {/* </Box> */}
                <hr />
                <div className="row">
                  <h4>Certificate Details</h4>
                  {/* <Box sx={{ display: 'flex', gap: 2 }}> */}
                  <div className="col-md-4 cs-form mb-2">
                    <TextField
                      // disabled="false"
                      disabled={values.certificateListId !== 13} 
                      name="otherCertName"
                      label="Certificate Name"
                      className='md-input'
                      value={values.otherCertName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.shipmentProductLotNo && Boolean(errors.shipmentProductLotNo)}
                      helperText={touched.shipmentProductLotNo && errors.shipmentProductLotNo}
                    />
                  </div>
                  <div className="col-md-4 cs-form mb-2">
                    <TextField
                      name="credentialsId"
                      label="Credentials Id"
                      className='md-input'
                      // type="number"
                      value={values.credentialsId}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.credentialsId && Boolean(errors.credentialsId)}
                      helperText={touched.credentialsId && errors.credentialsId}
                    />
                  </div>
                  <div className="col-md-4 cs-form mb-2">

                    <TextField
                      name="credentialsUrl"
                      label="Credentials URL"
                      className='md-input'
                      value={values.credentialsUrl}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.credentialsUrl && Boolean(errors.credentialsUrl)}
                      helperText={touched.credentialsUrl && errors.credentialsUrl}
                    />
                  </div>
                  {/* </Box> */}
                </div>

                <div className='row mt-3'>
                  <div className="col-md-4 cs-form mb-2">
                    <Grid spacing={2}>
                      <Grid item xs={12}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            name='dateOfIssue'
                            label="Date of Issue"
                            value={values.dateOfIssue}
                            onChange={(newValue) => {
                              setFieldValue('dateOfIssue', newValue);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                error={errors.dateOfIssue}
                                helperText={errors.dateOfIssue}
                                fullWidth
                              />
                            )}
                          />
                        </LocalizationProvider>
                      </Grid>
                    </Grid>
                  </div>
                  {/* <div className="col-md-6 cs-form mb-3">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label={t('createOrder.orderDate')}
                        className='md-input'
                        value={values.orderDate}
                        onChange={(newValue) => {
                          setFieldValue('orderDate', newValue);
                        }}
                        disabled={actionType === 'edit'}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            className='md-input'
                            error={errors.orderDate}
                            helperText={errors.orderDate}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </div> */}
                  <div className="col-md-4 cs-form mb-6">
                    <Grid item xs={12} md={3}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          disabled={values.certificateDoesNotExpireYn !==false  ? true : false} 
                          name='dateOfExpiry'
                          label="Date of Expiry"
                          value={values.dateOfExpiry}
                          onChange={(newValue) => {
                            console.log('Chcekbox inside datepicker is ', values.certificateDoesNotExpireYn)
                            setFieldValue('dateOfExpiry', newValue);
                          }}
                          renderInput={(params) => <TextField {...params} variant="outlined" fullWidth />}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </div>
                </div>

                <div className="col-md-12 cs-form mb-3">
                  <div className="d-flex align-items-center">
                    <h5 className="mb-0 mr-3">This certificate doesnot expire &nbsp;</h5>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={values.certificateDoesNotExpireYn}
                          onChange={(e) => handleExportChange(e)}
                          name="certificateDoesNotExpireYn"
                          color="primary"
                        />
                      }
                    // label={'Is Company Export?'}
                    />
                  </div>
                </div>
                <hr />
                <div className="row m-3">
                  <div className="banner_padding">
                    <p className="banner_heading_text">Featured Image</p>
                    <input type="file" onChange={handleImageChange} />

                    <button
                      type="submit"
                      disabled={buttonDisabled}
                      className={!buttonDisabled ? "btn btn-primary greeen-btn md_btn" : "btn btn-secondary md_btn"} style={{
                        margin: "10px",
                        width: '116px'
                      }}
                      onClick={handleImageUpload}>
                      <span><i className="mdi mdi-plus-circle-outline"></i>Upload</span>
                    </button>
                    {!imageLoading ? (error ? <div className="text-warning">{errorMessage}</div> : <div className="text-success">Upload Success</div>)
                      : <div></div>}
                    {imageError.length > 0 ? <div className=" text-warning">{imageError}</div> : null}
                  </div>

                  <p>Certificate can be uploaded only in PDF format.
                    Max file size: up to 2MB.
                    You can upload maximum of 10 certificates.</p>
                </div>
                <div class="input-group mb-3">
                  <div className="col-md-12 cs-form mb-6 mt-3">
                  </div>
                </div>
                <div className="d-flex justify-content-center mt-3">

                  <button
                    className="btn btn-primary greeen-btn lg-btn"
                    type="submit"
                    variant="contained"
                    onClick={handleSubmit} // Use onClick to trigger form submission
                  // disabled={ isValid || isSubmitting }
                  >
                    {/* Create Business Unit */}
                    {actionType === "edit"
                      ? loading
                        ? "Submitting..."
                        : "Submit Certificate"
                      : loading
                        ? "Creating..."
                        : "Add Certificate"}
                  </button>
                </div>
              </form>)}
            }
          </Formik >
        </DialogContent>

      </BootstrapDialog>
    </React.Fragment>
  );
}

export default AddEditCertificateModalComponent;
